/** Tipos de mensagem WhatsApp encaminháveis no chat. */

export type WhatsAppForwardableKind =
  | "text"
  | "image"
  | "video"
  | "audio"
  | "document"
  | "sticker"
  | "contact";

export function classifyWhatsAppForwardKind(
  metadata: Record<string, unknown> | null | undefined,
  body: string,
): WhatsAppForwardableKind | null {
  const meta = metadata ?? {};
  const type = typeof meta.type === "string" ? meta.type : "";
  if (type === "contacts" || type === "contact" || Array.isArray(meta.contacts)) return "contact";
  if (type === "image") return "image";
  if (type === "video") return "video";
  if (type === "audio") return "audio";
  if (type === "document") return "document";
  if (type === "sticker") return "sticker";
  if (type === "interactive" || type === "poll" || type === "carousel") return null;
  if (meta.interactive || meta.carousel || meta.poll) return null;
  if (body.trim()) return "text";
  return null;
}

export function canForwardWhatsAppMessage(
  metadata: Record<string, unknown> | null | undefined,
  body: string,
  deletedAt?: string | null,
): boolean {
  if (deletedAt) return false;
  return classifyWhatsAppForwardKind(metadata, body) !== null;
}

export function whatsAppForwardKindLabel(kind: WhatsAppForwardableKind): string {
  switch (kind) {
    case "text":
      return "Texto";
    case "image":
      return "Imagem";
    case "video":
      return "Vídeo";
    case "audio":
      return "Áudio";
    case "document":
      return "Documento";
    case "sticker":
      return "Figurinha";
    case "contact":
      return "Contato";
    default:
      return "Mensagem";
  }
}
